import { ApiService } from '../../ApiService';
import { Department } from '../../../entities/applicant_tracking/Department';

export class DepartmentService {
  public static list(): Promise<Department[]> {
    return ApiService.get<Department[]>('/api/applicant_tracking/departments');
  }
}
